import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export const EducationModalHeading: React.FC = () => {
	return (
		<div className="border-stroke-weaker items-baseline border-b pr-8">
			<Text variant="heading" as="h1" size="small">
				<Translate value="corgi.psf.share.modals.heading.title" replacements={{ shareChannel: 'Instagram' }} />
			</Text>
		</div>
	);
};
